import { MaintenanceForwardingsDirectiveEntryKlass } from "../features/forwardings/types/maintenanceForwardingsDirectiveEntryKlasses.type";

export const maintenanceForwardingsDirectiveEntryKlasses: Partial<{
  [K in MaintenanceForwardingsDirectiveEntryKlass]: {
    label: string;
  }
}> = {
  [MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry]: {
    label: 'Diagnóstico e Orçamento',
  }
}
